import moment from 'moment';

export const today = () => ({
  dates: {
    startDate: moment()
      .startOf('day')
      .toDate(),
    endDate: moment()
      .startOf('day')
      .toDate()
  },
  comparison: {
    previousPeriod: {
      startDate: moment()
        .subtract(1, 'day')
        .startOf('day')
        .toDate(),
      endDate: moment()
        .subtract(1, 'day')
        .startOf('day')
        .toDate()
    },
    previousYear: {
      startDate: moment()
        .subtract(1, 'year')
        .startOf('day')
        .toDate(),
      endDate: moment()
        .subtract(1, 'year')
        .startOf('day')
        .toDate()
    }
  }
});

export const yesterday = () => ({
  dates: {
    startDate: moment()
      .subtract(1, 'days')
      .startOf('day')
      .toDate(),
    endDate: moment()
      .subtract(1, 'days')
      .startOf('day')
      .toDate()
  },
  comparison: {
    previousPeriod: {
      startDate: moment()
        .subtract(2, 'days')
        .startOf('day')
        .toDate(),
      endDate: moment()
        .subtract(2, 'days')
        .startOf('day')
        .toDate()
    },
    previousYear: {
      startDate: moment()
        .subtract(1, 'year')
        .subtract(1, 'day')
        .startOf('day')
        .toDate(),
      endDate: moment()
        .subtract(1, 'year')
        .subtract(1, 'day')
        .startOf('day')
        .toDate()
    }
  }
});

export const lastWeek = () => ({
  dates: {
    startDate: moment()
      .subtract(1, 'weeks')
      .startOf('week')
      .toDate(),
    endDate: moment()
      .subtract(1, 'weeks')
      .endOf('week')
      .startOf('day')
      .toDate()
  },
  comparison: {
    previousPeriod: {
      startDate: moment()
        .subtract(2, 'weeks')
        .startOf('week')
        .toDate(),
      endDate: moment()
        .subtract(2, 'weeks')
        .endOf('week')
        .startOf('day')
        .toDate()
    },
    previousYear: {
      startDate: moment()
        .subtract(1, 'weeks')
        .startOf('week')
        .subtract(1, 'year')
        .toDate(),
      endDate: moment()
        .subtract(1, 'weeks')
        .endOf('week')
        .startOf('day')
        .subtract(1, 'year')
        .toDate()
    }
  }
});

export const lastMonth = () => ({
  dates: {
    startDate: moment()
      .subtract(1, 'months')
      .startOf('month')
      .toDate(),
    endDate: moment()
      .subtract(1, 'months')
      .endOf('month')
      .startOf('day')
      .toDate()
  },
  comparison: {
    previousPeriod: {
      startDate: moment()
        .subtract(2, 'months')
        .startOf('month')
        .toDate(),
      endDate: moment()
        .subtract(2, 'months')
        .endOf('month')
        .startOf('day')
        .toDate()
    },
    previousYear: {
      startDate: moment()
        .subtract(1, 'months')
        .startOf('month')
        .subtract(1, 'year')
        .toDate(),
      endDate: moment()
        .subtract(1, 'months')
        .subtract(1, 'year')
        .endOf('month')
        .startOf('day')
        .toDate()
    }
  }
});

export const lastXDays = days => ({
  dates: {
    startDate: moment()
      .subtract(days - 1, 'days')
      .startOf('day')
      .toDate(),
    endDate: moment()
      .startOf('day')
      .toDate()
  },
  comparison: {
    previousPeriod: {
      startDate: moment()
        .subtract(days * 2 - 1, 'days')
        .startOf('day')
        .toDate(),
      endDate: moment()
        .subtract(days, 'days')
        .startOf('day')
        .toDate()
    },
    previousYear: {
      startDate: moment()
        .subtract(1, 'year')
        .subtract(days - 1, 'days')
        .startOf('day')
        .toDate(),
      endDate: moment()
        .subtract(1, 'year')
        .startOf('day')
        .toDate()
    }
  }
});

export const allTimeDates = () => ({
  dates: {
    startDate: moment('01/01/1970', 'MM/DD/YYYY')
      .startOf('day')
      .toDate(),
    endDate: moment()
      .startOf('day')
      .toDate()
  }
});

export const getPreviousPeriod = range => {
  const diff = moment(range.endDate).diff(range.startDate, 'days');

  return {
    startDate: moment(range.startDate)
      .subtract(diff + 1, 'days')
      .startOf('day')
      .toDate(),
    endDate: moment(range.startDate)
      .subtract(1, 'day')
      .startOf('day')
      .toDate()
  };
};

export const getPreviousYear = range => ({
  startDate: moment(range.startDate)
    .subtract(1, 'year')
    .startOf('day')
    .toDate(),
  endDate: moment(range.endDate)
    .subtract(1, 'year')
    .startOf('day')
    .toDate()
});
